import { gql } from '@apollo/client';

export const GET_OBJECTIONS_TYPES = gql`
	query GetObjectionsTypes {
		objectionTypes {
			id
			name
			createdAt
			updatedAt
		}
	}
`;
